<div class="modal-header">
    <h4 class="modal-title pull-left">
        {{garantLibelle}}
    </h4>

    <button mat-icon-button class="pull-right" (click)="bsModalRef.hide()" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
    </button>
</div>
<div class="modal-body" [ngBusy]="{
      busy: busyGet,
      message: 'Veuillez patienter ...',
      backdrop: false
    }">
    <ng-container>
        <div class="row">
            <mat-tab-group mat-align-tabs="start" #tabGroup (selectedIndexChange)="selectedChangeValue($event)"
                  [(selectedIndex)]="indiceTab">
                  <mat-tab label="INFO DE BASE">
                    <div *ngIf="indiceTab == 0" style="overflow-x: hidden;padding: 10px;">
                        <app-garant-base-info [dataGarant]="currentData" (onGetGarantInfo)="onGetGarantInfo($event)"></app-garant-base-info>
                    </div>
                  </mat-tab>
                  <mat-tab label="POLICES">
                    <div *ngIf="indiceTab == 1" style="overflow-x: hidden;padding: 10px;">
                        <app-garant-detail-police [garantData]="garantData"></app-garant-detail-police>
                    </div>
                  </mat-tab>
                  <mat-tab label="COLLEGES">
                    <div *ngIf="indiceTab == 2" style="overflow-x: hidden;padding: 10px;">
                        <app-garant-detail-college [garantData]="garantData"></app-garant-detail-college>
                    </div>
                  </mat-tab>
                </mat-tab-group>

        </div>
    </ng-container>
</div>

<div class="modal-footer modal-footer-custom">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
     

        <button type="button" class="btn btn-md btn-cancel pull-right" (click)="bsModalRef.hide()">
            Fermer
        </button>
    </div>
</div>